import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/utils/cn';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'default' | 'ghost';
  size?: 'default' | 'mini';
  block?: boolean;
  round?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  children?: ReactNode;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'default', size = 'default', block = false, round = false, leftIcon, rightIcon, className, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          // 基础样式
          'inline-flex items-center justify-center font-medium transition-colors',
          'disabled:opacity-50 disabled:pointer-events-none',
          // 尺寸
          size === 'default' && 'px-4 py-2 text-base',
          size === 'mini' && 'px-2 py-1 text-xs',
          // 圆角
          round ? 'rounded-full' : 'rounded-lg',
          // 宽度
          block && 'w-full',
          // 变体
          variant === 'primary' && 'bg-primary text-white hover:opacity-90 active:opacity-80',
          variant === 'default' && 'bg-bg-page text-text-primary hover:bg-border-color active:bg-border-color/80',
          variant === 'ghost' && 'bg-transparent text-text-primary hover:bg-bg-page active:bg-border-color border border-border-color',
          className,
        )}
        {...props}
      >
        {leftIcon && <span className="mr-2 inline-flex items-center">{leftIcon}</span>}
        {children}
        {rightIcon && <span className="ml-2 inline-flex items-center">{rightIcon}</span>}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
